var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackWhiteIconSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.576,
    height: 20.93,
    viewBox: "0 0 21.576 20.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5141",
    "data-name": "Rectangle 5141",
    width: 21.576,
    height: 20.93,
    transform: "translate(99.02 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9578",
    "data-name": "Group 9578",
    transform: "translate(859.98 22861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9567",
    "data-name": "Group 9567",
    transform: "translate(-959 -22861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9566",
    "data-name": "Group 9566",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27467",
    "data-name": "Path 27467",
    d: "M108.805,3.8h-.1a1.4,1.4,0,0,0-1.36,1.06l1.74,1.74a1.407,1.407,0,0,0,1.05-1.37,1.384,1.384,0,0,0-1.33-1.43m3.81-.47h-.1a1.425,1.425,0,1,0,1.42,1.43,1.37,1.37,0,0,0-1.306-1.43h-.009m3.32,2.38h-.09a1.425,1.425,0,1,0,1.42,1.43V7.07a1.362,1.362,0,0,0-1.33-1.36M111.565,0h-.24a12.468,12.468,0,0,0-6.84,2l1.45,1.45a10.2,10.2,0,0,1,5.39-1.55h.24c3.85,0,7.13,2.61,7.13,5.71,0,2.45-.48,4.31-3.63,4.97l1.45,1.45c2.36-.9,4.08-2.8,4.08-6.42,0-4.28-4.28-7.61-9.03-7.61m7.47,18.65-4.16-4.16h-.01l-1.67-1.68h-.02l1.68,1.68,4.27,4.27a.477.477,0,0,0-.09-.11M103.285,2.89c-.01,0-.01.01-.02.01l1.44,1.44c0-.01,0-.01.01-.01Zm5.52.91h-.1a1.4,1.4,0,0,0-1.36,1.06l1.74,1.74a1.407,1.407,0,0,0,1.05-1.37,1.384,1.384,0,0,0-1.33-1.43m3.81-.47h-.1a1.425,1.425,0,1,0,1.42,1.43,1.37,1.37,0,0,0-1.306-1.43h-.009m3.32,2.38h-.09a1.425,1.425,0,1,0,1.42,1.43V7.07a1.362,1.362,0,0,0-1.33-1.36",
    fill: "#991F1F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27468",
    "data-name": "Path 27468",
    d: "M111.564,0h-.244a12.468,12.468,0,0,0-6.84,2l1.455,1.45A10.205,10.205,0,0,1,111.32,1.9h.24c3.85,0,7.13,2.61,7.13,5.71,0,2.45-.48,4.31-3.63,4.97l1.45,1.45c2.36-.9,4.08-2.8,4.08-6.42,0-4.28-4.28-7.61-9.03-7.61m1.63,12.81h-.019l1.679,1.68h.01Zm-9.9-9.92c-.011,0-.011.01-.021.01l1.44,1.44c0-.01,0-.01.01-.01Z",
    fill: "#991F1F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27469",
    "data-name": "Path 27469",
    d: "M110.135,5.23a1.407,1.407,0,0,1-1.05,1.37l-1.74-1.74a1.4,1.4,0,0,1,1.36-1.06h.1a1.384,1.384,0,0,1,1.33,1.43",
    fill: "#991F1F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27470",
    "data-name": "Path 27470",
    d: "M113.935,4.76a1.425,1.425,0,1,1-1.42-1.43h.1a1.369,1.369,0,0,1,1.321,1.416V4.76",
    fill: "#991F1F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27471",
    "data-name": "Path 27471",
    d: "M117.264,7.07v.06a1.425,1.425,0,1,1-1.43-1.42h.1a1.362,1.362,0,0,1,1.33,1.36",
    fill: "#991F1F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27472",
    "data-name": "Path 27472",
    d: "M103.285,2.89l1.429,1.44c-.01,0-.01,0-.01.01l-1.44-1.44c.01,0,.01-.01.021-.01",
    fill: "#991F1F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27473",
    "data-name": "Path 27473",
    d: "M119.12,18.76l-4.27-4.27-1.68-1.68h.02l1.67,1.68h.01l4.16,4.16a.476.476,0,0,1,.09.11",
    fill: "#991F1F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27474",
    "data-name": "Path 27474",
    d: "M119.164,18.81a.1.1,0,0,0-.04-.05l-4.27-4.27-1.68-1.68h.02l-8.48-8.48c-.01,0-.01,0-.01.01l-1.44-1.44c.01,0,.01-.01.02-.01L100.725.33a1,1,0,0,0-1.411,0,.9.9,0,0,0-.094.11.994.994,0,0,0,.094,1.31l2.571,2.57a9.71,9.71,0,0,0-2.21,6.14c0,5.81,3.8,10.47,10.219,10.47a2.519,2.519,0,0,0,1.19-4.76c-.43-.28-.48-1.43.95-1.43a2.251,2.251,0,0,0,.26-.01l5.33,5.33a.991.991,0,0,0,.71.3,1.228,1.228,0,0,0,.38-.07,1.057,1.057,0,0,0,.32-.23.975.975,0,0,0,.13-1.25m-9.08-1.03c.48.29.48.62.43.81a.577.577,0,0,1-.62.43c-5.75,0-8.32-4.28-8.32-8.56a7.7,7.7,0,0,1,1.746-4.7l.95.95a1.413,1.413,0,0,0-.32.9,1.428,1.428,0,0,0,1.42,1.43,1.368,1.368,0,0,0,.9-.33l4.37,4.37a2.92,2.92,0,0,0-1.65,1.8,2.606,2.606,0,0,0,1.09,2.9",
    fill: "#991F1F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27475",
    "data-name": "Path 27475",
    d: "M103.285,2.89l1.429,1.44c-.01,0-.01,0-.01.01l-1.44-1.44c.01,0,.01-.01.021-.01",
    fill: "#991F1F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27476",
    "data-name": "Path 27476",
    d: "M119.12,18.76l-4.27-4.27-1.68-1.68h.02l1.67,1.68h.01l4.16,4.16a.476.476,0,0,1,.09.11",
    fill: "#991F1F"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackWhiteIconSelected);
export default __webpack_public_path__ + "static/media/BlackWhiteIconSelected.0f3ab2863cae6b365630527b9caf507a.svg";
export { ForwardRef as ReactComponent };